const Authentication = {
  install(Vue) {
    Vue.mixin({
      computed: {
        currentUser () {
          return this.$store.state.user
        }
      }
    })
  }
}

export default Authentication
